// Canonical frontend release identity + What's New manifest (single source of truth).
// Release contract: bump `version` here AND the VERSION constant in public/sw.js together on
// every release so clients reliably install -> activate -> adopt the new bundle. Bump
// `releaseId` whenever the What's New notes should be shown again to users.
export const RELEASE = {
  version: "0.13.1",
  buildId: process.env.REACT_APP_BUILD_ID || "dev",
  releaseId: "2026.10-payments-019a",
  communicable: true,
  title: "Novità in K9 Manager 0.13.1",
  heading: "Pagamenti più chiari e precisi",
  paragraphs: [
    "Ogni incasso ha una destinazione! Quando registri un pagamento puoi associarlo a una prestazione, a un pacchetto oppure indicare un altro incasso specificandone la causale.",
    "Gestire gli acconti è più semplice: K9 Manager propone l'importo ancora da incassare, ma puoi modificarlo per registrare anche pagamenti parziali.",
    "Abbiamo migliorato i controlli sui pagamenti per aiutarti a evitare errori di associazione e importi superiori al residuo disponibile.",
  ],
  secondaryHeading: "Inoltre",
  secondaryParagraphs: [
    "Abbiamo migliorato la leggibilità delle descrizioni lunghe di prestazioni e pacchetti nel modulo Pagamenti, anche da smartphone.",
    "Stiamo costruendo K9 Manager insieme ai professionisti che lo utilizzano. Prova queste novità e raccontaci cosa funziona e cosa possiamo migliorare!",
  ],
};

// Namespaced, per-user + per-release acknowledgement key (localStorage is already origin-scoped,
// so Preview and Production never share this state).
export function whatsNewStorageKey(userId, releaseId) {
  return `k9_whatsnew_${userId || "anon"}_${releaseId}`;
}

// Pure decision: show the What's New dialog once per user per communicable release, and NEVER
// while a newer release is waiting to activate (notes must describe the release actually running).
export function shouldShowWhatsNew(release, userId, getItem, updatePending) {
  if (updatePending) return false;
  if (!release || !release.communicable) return false;
  return !getItem(whatsNewStorageKey(userId, release.releaseId));
}

// BUG-01: race-safe tri-state decision. `userReady` false means the authenticated user /
// acknowledgement state is still unresolved (do NOT show prematurely). `acknowledged` true
// means the exact communicable releaseId was already dismissed (persisted) — never show again.
// A different future releaseId arrives unacknowledged, so it stays eligible until dismissed.
export function whatsNewDecision({ release, userReady, updatePending, acknowledged }) {
  if (!release || !release.communicable) return false;
  if (!userReady) return false;      // unknown/loading -> do not show (not "not acknowledged")
  if (updatePending) return false;   // a newer release is waiting to activate
  if (acknowledged) return false;    // this releaseId already acknowledged/persisted
  return true;
}
